import { StreamActions } from "@hotwired/turbo"

StreamActions.redirect = function() {
  const url = this.getAttribute("url")
  if (url) {
    console.log('[Turbo Stream] Redirecting to:', url)
    window.location.href = url
  }
}
